import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { NavLink, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import callIcon from '../assets/icons/phone_icon.svg';
import userIcon from '../assets/icons/userIcon.svg';
import basketIcon from '../assets/icons/basketIcon.svg';
import useWindowSize from '../hooks/useWindowSize';
import menuOpenIcon from '../assets/icons/menuOpenIcon.svg';
import menuCloseIcon from '../assets/icons/menuCloseIcon.svg';
import TopHeaderLocalesDropDownTemplate from './TopHeaderLocalesDropDownTemplate';
import iconLocales from '../assets/icons/locations_icon_black.svg';
import arrowDownIcon from '../assets/icons/arrow_down_black.svg';
import toggleRegisterForm from '../store/actions/registerFormToggle';
import toggleBasketModal from '../store/actions/basketToggle';
import callToggle from '../store/actions/callToggle';
import listPng from '../assets/icons/Vector.svg';
import defaultUserImage from '../assets/images/user.jpeg';
import toggleMenuModal from '../store/actions/menuTogle';
import searchIcon from '../assets/icons/searchIcon.svg';
import Spinner from './Spinner';
import Api from '../api';
import { topMenu } from '../utils/data/topMenu';
import rateUsIcon from '../assets/icons/rate-us-icon.svg';

const rateUsLinks = {
  am: 'https://b24-p4lkbt.bitrix24.site/crm_form_e67nm/ ',
  ru: 'https://b24-p4lkbt.bitrix24.site/crm_form_cfdyi/ ',
  en: 'https://b24-p4lkbt.bitrix24.site/crm_form_znhfj/',
};
const height = localStorage.getItem('HeaderHeight');

function DropDownIconTemplate({ collapse }) {
  return (
    <img
      style={{ transform: collapse ? 'rotate(180deg)' : 'rotate(0deg)' }}
      src={arrowDownIcon}
      alt="arrow down"
    />
  );
}

function DropdownItemsTemplate({ item, isLast }) {
  return (
    <div className="dropdown-item mobile">
      <div className={`dropdown-item-icon-block ${item.icon ? 'languages' : ''}`}>
        <img src={item.icon ? item.icon : iconLocales} alt="" />
        <p className="dropdown-item-text">{item.name}</p>
      </div>
      <span className={`dropdown-item-bottom ${isLast ? 'last' : ''}`} />
      <div className="dropdown-item-hover-overlay" />
    </div>
  );
}

function BottomHeader({ data }) {
  const { user } = useSelector((state) => state.users);
  const dispatch = useDispatch();
  const [selectedCity, setSelectedCity] = useState(null);
  const { width } = useWindowSize();
  const { t } = useTranslation();
  const { menuVisible } = useSelector((state) => state.menuToggle);
  const lang = Cookies.get('i18next') || 'en';
  const { translations } = useSelector((state) => state.translation);
  const { isAuth } = useSelector((state) => state.users);
  const navigate = useNavigate();
  const localBasket = useSelector((state) => state.basketReducers.localBasket);
  const userBasket = useSelector((state) => state.users.cart);
  const { points } = useSelector((state) => state.points);
  const [suggestion, setSuggestion] = useState([]);
  const [noSuggests, setNoSuggests] = useState(false);
  const [query, setQuery] = useState('');
  const [isSuggestionsVisible, setIsSuggestionsVisible] = useState(false);
  const containerRef = useRef(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const cities = useMemo(() => data?.map((e) => ({
    name: e.address[lang],
    code: e.address[lang],
    id: e.id,
  })), [data]);
  useEffect(() => {
    document.body.style.overflow = menuVisible ? 'hidden' : 'auto';
  }, [menuVisible]);
  const toggleMenu = () => {
    dispatch(toggleMenuModal(!menuVisible));
  };
  useEffect(() => {
    const handler = setTimeout(async () => {
      setNoSuggests(false);
      if (query) {
        setIsSuggestionsVisible(true);
        setSearchLoading(true);
        const { data: response } = await Api.getSearchResults(query);
        setSearchLoading(false);
        setSuggestion(response.data);
        if (response.data.length === 0) {
          setNoSuggests(true);
        }
      } else {
        setIsSuggestionsVisible(false);
      }
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [query]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsSuggestionsVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleOpenRegisterModal = () => {
    if (isAuth) {
      toggleMenu();
      navigate(`/${lang}/account`);
    } else {
      dispatch(toggleRegisterForm({ visible: true, type: 'register' }));
    }
  };
  const suggestionsVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.2 } },
    exit: { opacity: 0, y: -10, transition: { duration: 0.2 } },
  };
  const handleOpenBasket = () => {
    dispatch(toggleBasketModal({ visible: true }));
  };
  const handleCloseModal = () => {
    dispatch(callToggle({ visible: true, isCall: true, item: null }));
  };
  const highlightMatch = (text) => {
    if (!query) return text;
    if (!text) return null;
    const regex = new RegExp(`(${query})`, 'gi');
    const parts = text.split(regex);

    return parts.map((part, i) => (regex.test(part) ? (
    // eslint-disable-next-line react/no-array-index-key
      <span key={i} style={{ color: '#005AA8' }}>
        {part}
      </span>
    ) : (
      part
    )));
  };
  return (
    <header className="header">
      <div className="container">
        <div className="header-row">
          <div className="main_navigation">

            <NavLink
              onClick={(e) => {
                e.preventDefault();
                window.location.href = `/${lang}`;
              }}
              to={`/${lang}`}
              className="header__logo"
            >
              <img
                fetchPriority="high"
                src="/logo/ecosense-logo-svg.svg"
                alt="logo"
                className="header__logo-image"
              />
            </NavLink>
            {width > 768 && (
            <nav className="header__nav">
              <ul className="header__menu">
                {topMenu.map((e) => (
                  <li key={e.id} className="header__menu-item">
                    <NavLink
                      to={`/${lang}${e.url[lang]}`}
                      className="header__menu-link"
                      onClick={(event) => {
                        event.preventDefault();
                        window.location.href = `/${lang}${e.url[lang]}`;
                      }}
                    >
                      {e.title[lang]}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>
            )}
          </div>

          <div className="header__actions">
            <div className="header__actions-account">
              <button onClick={handleOpenBasket} type="button">
                <img src={basketIcon} alt="basketIcon" />
                <div className="widget">
                  <p>{isAuth ? userBasket.length : localBasket.length}</p>
                </div>
              </button>
              {!isAuth ? (
                <button onClick={handleOpenRegisterModal} type="button">
                  <img src={userIcon} alt="userIcon" />
                </button>
              ) : (
                <button className="open-user-account-btn" onClick={handleOpenRegisterModal} type="button">
                  {user.image_path ? <img src={user.image_path} alt="userIcon" /> : <img src={defaultUserImage} alt="userIcon" />}
                  {width > 768 && (
                  <div className="user-acc-btn-bonuses">
                    <img className="list-icon" src={listPng} alt="list" />
                    <p>{points}</p>
                  </div>
                  )}
                </button>
              )}
              {width < 768 && (
              <button onClick={toggleMenu} type="button">
                <img src={menuVisible ? menuCloseIcon : menuOpenIcon} alt="menuIcon" />
              </button>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <div style={{ background: 'red' }}
      className={`header__nav-mobile ${isMenuOpen && width < 768 ? 'open' : ''}`}> */}
      <div
        style={{
          height: width < 768 ? `calc(100% - ${height}px)` : '100vh',
        }}
        className={`sidebar mobile ${menuVisible ? 'visible' : ''}`}
        // ref={sidebarRef}
      >
        <div className="container mobile-menu">
          <div className="header__nav-mobile-row">
            <nav>
              <div className="search-bar-container" ref={containerRef}>
                <div style={{ width: '100%', maxWidth: '100%', marginTop: '10px' }} className="search-bar">
                  <input
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    type="text"
                    className="search-bar-input"
                    placeholder={translations?.search_input?.[lang]}
                  />
                  <img src={searchIcon} alt="" className="search-bar-icon" />
                </div>
                {isSuggestionsVisible && (
                <motion.div
                  className="search-bar-suggestions"
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  variants={suggestionsVariants}
                >
                  <ul>
                    {searchLoading && <Spinner isSearch size={50} width={50} height={50} />}
                    {noSuggests && <li className="suggestion-item">{t('no_suggestion')}</li>}
                    {searchLoading || suggestion.map((item) => (
                      <li
                        role="presentation"
                        onClick={() => {
                          if (item.model_type === 'Address') {
                            navigate(`/${lang}/addresses?address=${item.id}`);
                          } else {
                            window.location.assign(`/${lang}/section-description/${item.slug[lang]}`);
                          }
                        }}
                        className="suggestion-item"
                        key={item.id + item.model_type}
                      >
                        {highlightMatch(item.model_type === 'Address' ? item.address[lang] : item.title[lang], query)}
                      </li>
                    ))}
                  </ul>
                </motion.div>
                )}
              </div>
              <ul className="header__menu">
                {topMenu.map((e) => (
                  <li key={e.id} className="header__menu-item">
                    <NavLink to={`/${lang}${e.url[lang]}`} className="header__menu-link">
                      {e.title[lang]}
                    </NavLink>
                  </li>
                ))}
                <div className="mobile-menu-line" />
                <Dropdown
                  panelClassName="locations-dropdown-panel mobile"
                  className="locations-dropdown mobile"
                  dropdownIcon={() => <DropDownIconTemplate collapse={false} />}
                  collapseIcon={() => <DropDownIconTemplate collapse />}
                  valueTemplate={() => (
                    <TopHeaderLocalesDropDownTemplate
                      icon={iconLocales}
                      title={selectedCity ? selectedCity.name : translations?.locations?.[lang]}
                    />
                  )}
                  itemTemplate={(element) => (
                    <DropdownItemsTemplate
                      item={element}
                      isLast={element.name === cities[cities.length - 1].name}
                    />
                  )}
                  value={selectedCity}
                  onChange={(e) => {
                    localStorage.setItem('city', JSON.stringify(e.value));
                    setSelectedCity(e.value);
                    navigate(`/${lang}/addresses?address=${e.value.id}`);
                  }}
                  options={cities}
                  optionLabel="ывыв"
                  placeholder="Select a Locations"
                />
                <li className="rate-us-button">
                  <a
                    href={rateUsLinks[lang]}
                    className="top-header__link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={rateUsIcon} alt="rate us" className="top-header__icon" />
                    <p>RATE US!</p>
                  </a>
                </li>
              </ul>
            </nav>
            <div className="header__actions-contact">
              <div className="header__actions-telegram">
                <a target="_blank" href="https://t.me/EcoSene_bot" rel="noreferrer">{translations?.telegram_bot?.[lang]}</a>
              </div>
              <div
                role="presentation"
                onClick={handleCloseModal}
                className="header__actions-telegram call-btn"
              >
                <img src={callIcon} alt="callIcon" />
                <p>{translations?.home_call_btn?.[lang]}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </header>
  );
}

export default BottomHeader;
